module.exports = __webpack_public_path__ + "media/images/emblems/Montreux-coat_of_arms-aed5c4f81012b64ac03afbad65a8ce7b.svg";